module.exports = __webpack_public_path__ + "static/media/informe1foto1.f664605a.jpg";